import { T, compose, cond, isNil, toString } from "ramda";
import { setNodeValue } from '../../../xmlUtility';
import { success } from "./commandResult";
import { DATA_SOURCE_NAME_QDABRA_RULES } from "./qdabraRulesDs.helpers";


const qRulesExecutionHistoryPath = '/QdabraRules/ExecutionHistory';

function formatResultData(result) {
    const resultData = 'result' in result ? result.result : result.Result;

    if (typeof resultData === 'number') {
        return resultData.toString();
    }

    return resultData || '';
}

const isPrimitive = (value) =>
    typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';

const normalizeResultObject = (result) => ({
    success: ('success' in result ? result.success : result.Success) || false,
    result: formatResultData(result),
    error: ('error' in result ? result.error : result.Error) || '',
});

export const normalizeResult = cond([
    [isNil, () => success('', 'Warning: command completed with no result.')],
    [isPrimitive, (result) => success(result.toString())],
    [T, normalizeResultObject],
]);


const populateHistory = (commandString, commandResultData, dataSources) => {
    // We must find the data source here and select history from there
    // becuase finding the history relative to the command node can cause
    // issues witht the dataSourceName not being set correctly on inserted nodes
    const qRulesDom = dataSources.getDom(DATA_SOURCE_NAME_QDABRA_RULES);

    if (!qRulesDom) {
        return;
    }

    let executionHistory = qRulesDom.selectSingle(qRulesExecutionHistoryPath);

    if (!executionHistory) {
        return;
    }

    let historyNode = executionHistory.createElement('History');
    let historyCommandNode = executionHistory.createElement('Command');
    let resultNode = executionHistory.createElement('Result');
    let successNode = executionHistory.createElement('Success');
    let errorNode = executionHistory.createElement('Error');

    setNodeValue(historyCommandNode, commandString);
    setNodeValue(resultNode, commandResultData.result);
    setNodeValue(successNode, commandResultData.success);
    setNodeValue(errorNode, commandResultData.error);

    historyNode.appendChild(historyCommandNode);
    historyNode.appendChild(resultNode);
    historyNode.appendChild(successNode);
    historyNode.appendChild(errorNode);

    return executionHistory.appendChildAsync(historyNode);
}

// (DataSourceNode, String, DataSources) -> CommandResult -> Promise[void]
export const populateResult = (commandNode, commandString, dataSources) => async (resultObject) => {
    let resultNode = commandNode.selectSingle("../Result");
    let successNode = commandNode.selectSingle("../Success");
    let errorNode = commandNode.selectSingle("../Error");

    if (resultNode) {
        await resultNode.setValueAsync(resultObject.result);
    }

    if (successNode) {
        await successNode.setValueAsync(resultObject.success);
    }

    if (errorNode) {
        await errorNode.setValueAsync(resultObject.error);
    }

    await populateHistory(commandString, resultObject, dataSources);
};
